<template>
  <div class="warning">
    <div class="warning__text-block">
      <div class="warning__title">
        <p class="warning__title__text">
          ВНИМАНИЕ!<br/>
          ЭТО ЧАСТНАЯ КОМПЬЮТЕРНАЯ СИСТЕМА, ПРИНАДЛЕЖАЩАЯ ГРУППЕ СОЛЛЕРС. ЕЁ ИСПОЛЬЗОВАНИЕ ОТСЛЕЖИВАЕТСЯ. НЕПРАВОМЕРНЫЙ ДОСТУП ИЛИ ИСПОЛЬЗОВАНИЕ МОГУТ ПОВЛЕЧЬ УГОЛОВНУЮ ОТВЕТСТВЕННОСТЬ, ПРИМЕНЕНИЕ ДИСЦИПЛИНАРНЫХ МЕР ВПЛОТЬ ДО УВОЛЬНЕНИЯ, РАСТОРЖЕНИЯ ДОГОВОРА ИЛИ ЗАПРЕТА ДОСТУПА К СИСТЕМЕ.
        </p>
      </div>
      <div class="warning__main">
        <p class="warning__main__text">
            Система может содержать конфиденциальные данные Группы СОЛЛЕРС, аффилированных с ней компаний, дилеров и поставщиков. Эти данные не подлежат разглашению без надлежащего разрешения со стороны Группы СОЛЛЕРС. Вы отвечаете за безопасность и конфиденциальность информации, к которой получаете доступ, а также подтверждаете, что будете использовать её только для целей, согласованных с Группой СОЛЛЕРС.
        </p>
        <p class="warning__main__text">
            Группа СОЛЛЕРС обладает всеми правами на необнародованные произведения, созданные Группой СОЛЛЕРС и созданные для неё, а также сохраняет за собой право защищать авторские права как на обнародованные, так и на необнародованные произведения.
        </p>
        <p class="warning__main__text">
          Продолжая использовать эту Систему, вы соглашаетесь с этими условиями использования.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Warning',
};
</script>

<style lang="scss" scoped>
.warning {
  width: 100%;


  &__title {
    &__text {
      font-weight: bold;
      font-size: 10px;
      margin-bottom: 0px;
      text-align: justify;
    }
  }

  &__main {
    &__text {
      color: var(--ford-reqular-text);
      font-size: 10px;
      margin-bottom: 0px;
      text-align: justify;
    }
  }
}
</style>
